export const QA_NAME_APPOINTMENT_FOLLOW_UP_MODAL = 'appointmentFollowUpModal'

export const QA_NAME_APPOINTMENT_FOLLOW_UP_DAY_LOAD =
  'appointmentFollowUpDayLoad'

export const QA_NAME_APPOINTMENT_FOLLOW_UP_DAY_LOAD_FAILED =
  'appointmentFollowUpDayLoadFailed'
